// H-89: default group size when the wizard opens.
// Shared by EventDraftContext and step components — single source of truth.
export const MIN_GROUP_SIZE = 2;

// M-445: lowest value the group-size stepper will accept (solo events are valid).
export const MIN_ALLOWED_GROUP_SIZE = 1;

export const STORAGE_KEY = 'planacle_draft_event_v2';
